<template>
  <v-select
    :items="selos"
    v-model="model"
    label="Tipo de selo"
    item-text="name"
    item-value="value"
    max-height="50%"
    cache-items>
    <template slot="item" slot-scope="data">

      <template v-if="typeof data.item !== 'object'">
        <v-list-tile-content v-text="data.item"></v-list-tile-content>
      </template>

      <template v-else>
        <div class="dd-container"
             :class="{'mobile': $vuetify.breakpoint.xsOnly, 'grupo-selo-1' : data.item.group === 1}">
          <div class="dd-image">
            <img :src="data.item.avatar">
          </div>
          <div class="dd-text">
            <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
          </div>
        </div>
      </template>

    </template>
  </v-select>
</template>

<script>
  import Selo from '../../domain/selo/selo';

  export default {
    name: "SelectSelo",
    props: {
      value: {
        type: Number,
        default: 9
      }
    },
    data() {
      return {
        selos: [
          {header: 'A partir de 01/04/2013'},
          {value: 9, name: 'Digital', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 10, name: 'Digital (Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          // {value: 11, name: 'Digital (Reg. Civil)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 12, name: 'Digital (Reg. Civil - Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          // {value: 13, name: 'Digital (Notas)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 14, name: 'Digital (Notas - Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          // {value: 15, name: 'Digital (Imóveis)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 16, name: 'Digital (Imóveis - Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          // {value: 17, name: 'Digital (Protesto)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 18, name: 'Digital (Protesto - Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          // {value: 19, name: 'Digital (RTD e PJ)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 20, name: 'Digital (RTD e PJ - Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          // {value: 21, name: 'Digital (Dist. Protesto)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL')},
          // {value: 22, name: 'Digital (Dist. Protesto - Isento)', group: 1, avatar: Selo.getImagePath('SELO DIGITAL ISENTO')},
          {divider: true},
          {header: 'A partir de 06/08/2010'},
          {value: 1, name: 'Autenticação', group: 2, avatar: Selo.getImagePath('AUTENTICAÇÂO')},
          {value: 2, name: 'Reconhecimento de firma', group: 2, avatar: Selo.getImagePath('RECONHECIMENTO DE FIRMA')},
          {value: 3, name: 'Certidão', group: 2, avatar: Selo.getImagePath('CERTIDÃO')},
          {value: 4, name: 'Ato Notarial e Registral', group: 2, avatar: Selo.getImagePath('NOTARIAL E REGISTRAL')},
          {value: 5, name: 'Ato Isento', group: 2, avatar: Selo.getImagePath('ISENTO - VERMELHO')},
          {divider: true},
          {header: 'Anteriores a 06/08/2010'},
          {value: 6, name: 'Fiscalização (1 Ato)', group: 3, avatar: Selo.getImagePath('FISCALIZAÇÃO (01 ATO)')},
          {value: 7, name: 'Fiscalização (2 Atos)', group: 3, avatar: Selo.getImagePath('FISCALIZAÇÃO (02 ATOS)')},
          {value: 8, name: 'Fiscalização (Isento)', group: 3, avatar: Selo.getImagePath('FISCALIZAÇÃO (ISENTO)')}
        ]
      }
    },
    mounted: function() {
      this.model = this.value;
    },
    computed: {
      model: {
        get () { return this.value },
        set (value) { this.$emit('input', value) },
      },
    },
  }
</script>

<style>
  .list__tile--avatar {
    height: 110px !important;
  }

  .mobile .list__tile--avatar {
    height: 90px !important;
  }

  .dd-container {
    display: grid;
    grid-template-columns: 110px;
    grid-column-gap: 14px;
    width: 100%;
  }

  .mobile.dd-container:not(.grupo-selo-1) {
    grid-template-columns: 100px 1fr;
  }

  .dd-image {
    grid-column: 1;
    padding: 10px;
  }

  .dd-image img {
    width: 100%;
  }

  .dd-text {
    margin: auto 0;
    grid-column: 2;
  }

  .mobile .dd-text {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/consulta/SelectSelo.vue